/* Temizo/Wellnax tema etkileşimleri */
(function () {
  "use strict";

  /* ---- Para biçimlendirme (Shopify money_format ile) ---- */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2).replace(".", ",");
    // 1.199,00 → binlik ayracı ekle
    var parts = value.split(",");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var whole = parts[1] === "00" ? parts[0] : parts.join(",");
    return (format || "{{amount}} TL")
      .replace(/\{\{\s*amount[^}]*\}\}/, whole)
      .replace(/<[^>]+>/g, "");
  }

  /* ---- Geri sayım: İstanbul gün sonu ---- */
  var countdown = document.getElementById("countdown");
  if (countdown) {
    var pad = function (n) { return String(n).padStart(2, "0"); };
    var tick = function () {
      var now = new Date();
      var ist = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Istanbul" }));
      var midnight = new Date(ist);
      midnight.setHours(24, 0, 0, 0);
      var left = midnight - ist;
      countdown.querySelector('[data-unit="h"]').textContent = pad(Math.floor(left / 3600000));
      countdown.querySelector('[data-unit="m"]').textContent = pad(Math.floor((left % 3600000) / 60000));
      countdown.querySelector('[data-unit="s"]').textContent = pad(Math.floor((left % 60000) / 1000));
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Galeri ---- */
  var track = document.getElementById("gallery-track");
  var dots = document.getElementById("gallery-dots");
  var counter = document.getElementById("gallery-current");
  if (track && dots) {
    var setActive = function (i) {
      dots.querySelectorAll("button").forEach(function (b, j) {
        b.setAttribute("aria-current", i === j ? "true" : "false");
      });
      if (counter) counter.textContent = i + 1;
    };
    track.addEventListener("scroll", function () {
      setActive(Math.round(track.scrollLeft / track.clientWidth));
    }, { passive: true });
    dots.addEventListener("click", function (e) {
      var btn = e.target.closest("button[data-index]");
      if (!btn) return;
      var i = Number(btn.dataset.index);
      track.scrollTo({ left: i * track.clientWidth, behavior: "smooth" });
      setActive(i);
    });
  }

  /* ---- Paket seçici + sepete ekle ---- */
  var bundleList = document.getElementById("bundle-list");
  var buyButton = document.getElementById("buy-button");
  var addonCheck = document.getElementById("addon-check");
  if (bundleList && buyButton) {
    var moneyFormat = buyButton.dataset.moneyFormat;

    var updateButton = function () {
      var selected = bundleList.querySelector('[aria-checked="true"]');
      if (!selected) return;
      var total = Number(selected.dataset.price);
      if (addonCheck && addonCheck.checked) total += Number(addonCheck.dataset.price);
      buyButton.textContent = selected.dataset.title + " Al — " + formatMoney(total, moneyFormat);
    };

    bundleList.addEventListener("click", function (e) {
      var card = e.target.closest(".bundle-card");
      if (!card) return;
      bundleList.querySelectorAll(".bundle-card").forEach(function (c) {
        c.setAttribute("aria-checked", "false");
      });
      card.setAttribute("aria-checked", "true");
      updateButton();
    });
    if (addonCheck) addonCheck.addEventListener("change", updateButton);
    updateButton();

    buyButton.addEventListener("click", function () {
      var selected = bundleList.querySelector('[aria-checked="true"]');
      if (!selected) return;
      buyButton.disabled = true;
      buyButton.textContent = "Sepet hazırlanıyor...";

      var items = [{ id: Number(selected.dataset.variantId), quantity: 1 }];
      if (addonCheck && addonCheck.checked) {
        items.push({ id: Number(addonCheck.dataset.variantId), quantity: 1 });
      }

      // Önce sepeti sıfırla ki tekrar denemede adet katlanmasın, sonra ekle → direkt ödeme
      fetch("/cart/clear.js", { method: "POST" })
        .then(function () {
          return fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: items }),
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error("add failed");
          window.location.href = "/checkout";
        })
        .catch(function () {
          buyButton.disabled = false;
          buyButton.textContent = "Tekrar deneyin";
        });
    });
  }

  /* ---- Scroll-reveal ---- */
  var revealEls = document.querySelectorAll("[data-reveal]");
  if (revealEls.length && "IntersectionObserver" in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("revealed");
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -40px" });
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("revealed"); });
  }

  /* ---- Sabit alt bar ---- */
  var sticky = document.getElementById("sticky-cta");
  var heroCta = document.getElementById("hero-cta");
  var bundles = document.getElementById("paketler");
  if (sticky && heroCta) {
    var pastHero = false;
    var onBundles = false;
    var update = function () {
      sticky.classList.toggle("visible", pastHero && !onBundles);
    };
    new IntersectionObserver(function (entries) {
      pastHero = !entries[0].isIntersecting;
      update();
    }, { rootMargin: "-40px" }).observe(heroCta);
    if (bundles) {
      new IntersectionObserver(function (entries) {
        onBundles = entries[0].isIntersecting;
        update();
      }, { threshold: 0.2 }).observe(bundles);
    }
  }
})();
